module.exports = __webpack_public_path__ + "img/Ke.b3cfe35f.png";